// TODO: replace this in cache of articles, then this is obsolete.
function clickKey(id,parentElement) {
	
	//pak class names van parent om straks te kijken of er een class in zit
	var classParent = parentElement.className;
	
	//kijk of de item dicht is doormiddel van class om niet te tracken als je hem opent
	if (classParent.indexOf('titleOfCollapsedItem') > -1) {
		return false;
	}
	
	II.clickTrack(id);
}
// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
